import ManageUserFeedbackPage from './ManageUserFeedbackPage';

export default ManageUserFeedbackPage;
export { default as reducer } from './userFeedback.ducks';



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageUserFeedbackPage/index.ts